import request from '@/utils/request'

// 查询知识产权专家信息列表
export function listZjxx(query) {
  return request({
    url: '/web/zscq/zjxx/list',
    method: 'get',
    params: query
  })
}

// 查询知识产权专家信息详细
export function getZjxx(recid) {
  return request({
    url: '/web/zscq/zjxx/' + recid,
    method: 'get'
  })
}

// 新增知识产权专家信息
export function addZjxx(data) {
  return request({
    url: '/web/zscq/zjxx',
    method: 'post',
    data: data
  })
}

// 修改知识产权专家信息
export function updateZjxx(data) {
  return request({
    url: '/web/zscq/zjxx/edit',

    method: 'post',
    data: data
  })
}

// 删除知识产权专家信息
export function delZjxx(recid) {
  return request({
    url: '/web/zscq/zjxx/remove/' + recid,

    method: 'post',
  })
}

// 导出知识产权专家信息
export function exportZjxx(query) {
  return request({
    url: '/web/zscq/zjxx/export',
    method: 'get',
    params: query
  })
}

export function importTemplate() {
  return request({
    url: '/web/zscq/zjxx/importTemplate',
    method: 'get'
  })
}
